import React, { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

const SuccessModal = ({ show, message, onClose, autoReload = true, reloadDelayMs = 5000 }) => {
  useEffect(() => {
    let t = null;
    if (show && autoReload) {
      t = setTimeout(() => {
        window.location.reload();
      }, reloadDelayMs);
    }
    return () => { if (t) clearTimeout(t); };
  }, [show, autoReload, reloadDelayMs]);

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Success</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message || "Operation completed successfully."}</p>
        <p className="small text-muted">This page will reload automatically in {reloadDelayMs / 1000} seconds.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClose}>OK</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuccessModal;
